module.exports = __webpack_public_path__ + "static/media/29DUNON9.9f35fcbb.jpg";